<template>
  <div style="background-color: #fff;min-height: 100vh;">
    <div>
      <van-nav-bar :title="$t('detail.details')" fixed left-arrow @click-left="onClickLeft" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>
    <van-swipe v-if="data.img_url && data.img_url.length > 0" style="height: 440px;" autoplay="5000" loop>
      <van-swipe-item v-for="item in data.img_url" :key="item">
        <img style="width:100%;height:100%;object-fit: cover;" :src="$baseURL+item" />
      </van-swipe-item>
    </van-swipe>
    <div class="container">
      <div class="infoBox">
        <p class="name">ID:#{{ ('' + (data.id || '')).slice(0,3) }}**</p>
        <p class="text">{{ $t('detail.age') }}: {{data.age}} &nbsp;{{ $t('detail.height') }}: {{data.hight}}CM &nbsp;<span>{{ $t('detail.bust') }}: {{data.bust}}</span> &nbsp;{{data.class_name}} &nbsp;{{data.address}}</p>
      </div>
      <div class="title" style="color: rgb(172, 98, 204);">{{ $t('detail.how_it_works') }}</div>
      <div class="process">
        <div class="item">
          <div class="img"></div>
          <p>{{ $t('detail.browse_online') }}</p>
        </div>
        <div class="item">
          <div class="img"></div>
          <p>{{ $t('detail.book_a_date') }}</p>
        </div>
        <div class="item">
          <div class="img"></div>
          <p>{{ $t('detail.meet_in_person') }}</p>
        </div>
        <div class="item">
          <div class="img"></div>
          <p>{{ $t('detail.leave_a_review') }}</p>
        </div>
      </div>
      <div class="title" style="color: rgb(172, 98, 204);">{{ $t('detail.profile') }}</div>
      <div class="profile">
        <div class="info">
          <div class="item">
            <p>{{data.age}} {{ $t('detail.age_unit') }}</p>
            <p>{{ $t('detail.age') }}</p>
          </div>
          <div class="item">
            <p>{{data.hight}} {{ $t('detail.cm') }} </p>
            <p>{{ $t('detail.height') }}</p>
          </div>
          <div class="item">
            <p>{{data.weight}}</p>
            <p>{{ $t('detail.weight') }}</p>
          </div>
        </div>
        <div class="info">
          <div class="item">
            <p>{{data.bust}}</p>
            <p>{{ $t('detail.bust') }}</p>
          </div>
          <!-- <div class="item">
            <p>{{data.class_name}}</p>
            <p>服务城市</p>
          </div> -->
          <!-- <div class="item">
            <p>{{data.address}}</p>
            <p>服务区域</p>
          </div> -->
        </div>
        <!-- <hr>
        <div class="info">
          <div class="item">
            <p>{{data.xiangMu}}</p>
            <p>服务项目</p>
          </div>
        </div> -->
        <hr style="margin: 0px;">
      </div>
      <div class="title" style="color: rgb(172, 98, 204);">{{ $t('detail.about') }}</div>
      <div class="images">{{data.jianjie}}</div>
      <div class="title" style="color: rgb(172, 98, 204);">{{ $t('detail.notes') }}</div>
      <div class="profile">
        <div class="info">
          <div class="item">
            <p>{{data.zhuYiShiXiang}}</p>
            <p></p>
          </div>
        </div>
      </div>
      <div class="btn" @click="showPop=true" style="background: rgb(172, 98, 204);">{{ $t('detail.meet_her') }}</div>
    </div>
    <order-pop v-if="showPop" @close="showPop=false" :infodata="data"></order-pop>
    <div style="padding-bottom: 20vw; background-color: transparent;"></div>
  </div>
</template>

<script>
import orderPop from './orderPop.vue'
import { getPipeLangIndex } from '@/common/locale'
export default {
  components:{
    orderPop
  },
  data() {
    return {
      data: {},
      showPop:false
    };
  },
  methods: {
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.data = res.data;
        // this.data.flag.forEach(item => {
        //   const parts = item.flag.split('|')
        //   item.flag = parts[0]
        //   item.flagArray = item.flag.split('，');

        // })
        const parts = this.data.flag.split('|')
        console.log(parts, 987)
        this.data.flag = parts[getPipeLangIndex()]
        this.data.flagArray = this.data.flag && this.data.flag.split('，');
        // this.currentImage = this.data.img_url[0];

        this.currentIndex = 0;
        this.currentImage = this.data.img_url[0];
        console.log(this.currentImage, "this.currentImage160")

        console.log(this.data, 998)
      });
    },
    onClickLeft() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getxuanfeidata();
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: initial;
}

/deep/ .van-nav-bar__title {
  color: #fff !important;
}

.van-nav-bar {
  background: transparent;
  border-bottom-width: 0;
}
.container {
    padding: 0 34px;
}
.container .infoBox {
    color: #000000;
    position: relative;
}
.container .infoBox .name {
    font-size: 28px;
    font-weight: bold;
}
.container .infoBox .text {
    font-size: 24px;
    font-weight: 400;
}
.container .title {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgb(172, 98, 204);
    padding: 34px 40px;
    background: url(/img/xin.png) no-repeat;
    background-size: 28px 26px;
    background-position: 0 center;
}
.container .process {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.container .process .item:nth-child(1) .img {
    background-image: url(/img/process1.png);
}
.container .process .item:nth-child(2) .img {
    background-image: url(/img/process2.png);
}
.container .process .item:nth-child(3) .img {
    background-image: url(/img/process3.png);
}
.container .process .item:nth-child(4) .img {
    background-image: url(/img/process4.png);
}
.container .process .item .img {
    height: 76px;
    background-size: 76px;
    background-position: center;
    background-repeat: no-repeat;
}
.container .process .item p {
    font-size: 24px;
    text-align: center;
    color: #ff556e;
    margin-top: 10px;
}
.container .profile .info {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
}
.container .profile .info .item {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    padding-left: 40px;
    padding-bottom: 20px;
}
.container .profile .info .item p:first-child {
    font-size: 28px;
    color: #ff556e;
}
.container .profile .info .item p:last-child {
    font-size: 24px;
    color: #000;
    font-weight: 400;
}
.container .profile hr {
    border-color: #ff556e;
    margin-bottom: 20px;
}
.btn {
    height: 74px;
    line-height: 74px;
    border-radius: 18px;
    background: #ff8395;
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #232323;
}
</style>
